var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkHorizontal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.118,
    height: 16.322,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6011",
    fill: "#5300f2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 232",
    d: "M13.704 7.31a.853.853 0 00-.852.851 2.563 2.563 0 01-2.56 2.56H6.029a2.559 2.559 0 010-5.118H8.65a.852.852 0 100-1.705H6.03a4.264 4.264 0 100 8.528h4.263a4.272 4.272 0 004.264-4.264.853.853 0 00-.852-.852z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 233",
    d: "M18.088 3.898h-4.264A4.27 4.27 0 009.56 8.162a.852.852 0 101.705 0 2.563 2.563 0 012.559-2.56h4.263a2.561 2.561 0 012.56 2.56 2.621 2.621 0 01-2.56 2.559l-2.618-.002a.852.852 0 000 1.704l2.618-.002a4.261 4.261 0 100-8.522z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkHorizontal);
export default __webpack_public_path__ + "static/media/link-horizontal.955cdca860372c6477aa16fc0d961867.svg";
export { ForwardRef as ReactComponent };